import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  margin-bottom: 20px;
`

const SLTitleSmall = () => (
  <Wrapper>
    <svg width="150px" height="8px" viewBox="0 0 150 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="1.0-Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Broker-Portal---Dashboard---Loading" transform="translate(-276.000000, -152.000000)" fill="#F1F1F4">
          <rect id="title-small" x="276" y="152" width="150" height="8"/>
        </g>
      </g>
    </svg>
  </Wrapper>
)

export default SLTitleSmall
